import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { DISPLAY_CONSTS } from './filter-icon.constants';

@Component({
  selector: 'app-filter-icon',
  templateUrl: './filter-icon.component.html',
  styleUrls: ['./filter-icon.component.scss'],
  standalone: false,
})
export class FilterIconComponent {
  @Input() isDisabled = false;
  @Output() clearFilterEvent = new EventEmitter();

  readonly DISP_CONSTS = DISPLAY_CONSTS;
  readonly IMAGES = IMAGE_SRC;

  clearFilter() {
    if (!this.isDisabled) {
      this.clearFilterEvent.emit();
    }
  }
}
